const routes = [


	//---- "Sales & CRM" module ----
	{
		path: '/module.crm',
		name: "crm-home",
		component: () => import("/module.crm/index.vue"),
		meta: { layout: "primary", module: "crm", parentRouteName: "", pageTitle: "Sales & CRM > Home" }
	},
	{
		path: '/module.crm/pipeline',
		name: "crm-pipeline",
		component: () => import("/module.crm/pipeline.vue"),
		meta: { layout: "primary", module: "crm", parentRouteName: "crm-home", pageTitle: "Sales & CRM > Pipeline" }
	},
	{
		path: '/module.crm/pipeline/:id',
		name: "crm-pipeline-detail",
		component: () => import("/module.crm/pipeline-detail.vue"),
		meta: { layout: "primary", module: "crm", parentRouteName: "crm-pipeline", pageTitle: "Sales & CRM > Pipeline - {dealName}" }
	},
	{
		path: '/module.crm/contacts',
		name: "crm-contacts",
		component: () => import("/module.crm/contacts.vue"),
		meta: { layout: "primary", module: "crm", parentRouteName: "crm-home", pageTitle: "Sales & CRM > Contacts" }
	},
	{
		// The Sales & CRM reports themselves are reports2 pages (navigation/routes.reports.js, /reports2/sales/...).
		path: '/module.crm/reports',
		name: "crm-reports",
		component: () => import("/module.crm/reports.vue"),
		meta: { layout: "primary", module: "crm", parentRouteName: "crm-home", pageTitle: "Sales & CRM > Reports" }
	},

]


export default routes;
